var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',[_c('CardTitle',{staticStyle:{"display":"block"}},[_c('VText',{attrs:{"component":"h2","variant":"h4"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("subtitle")],2),_vm._v(" "),_c('CardText',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }